import { DOCUMENTS_PATH } from 'commons/constants/routes'
import { Document } from 'commons/types/DTO/bank/companyDetails/document'
import { DateTime } from 'ui/components'
import { CheckMark } from 'ui/components/CheckMark'
import { IconSize } from 'ui/components/Icon'
import { FrequencyLabel } from 'ui/components/Labels'
import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'
import { TextMask } from 'ui/components/TextMask'

import { DueTooltip } from './components/DueTooltip/DueTooltip'

import * as SC from './styles'

export const columns = (
  onDeleteDocument: (document: Document | undefined) => void,
  returnUrl?: string
): TableColumn<Document>[] => [
  {
    title: 'Document Name',
    sortable: true,
    key: 'documentName',
    align: 'left',
    render: (item) => (
      <Link to="/documents/$documentId" params={{ documentId: item.id.toString() }}>
        <SC.CellLongString>{item.documentName}</SC.CellLongString>
      </Link>
    )
  },
  {
    title: 'Internal',
    sortable: true,
    key: 'isInternal',
    render: ({ isInternal }) => (isInternal ? <CheckMark value rounded /> : null)
  },
  {
    title: 'Subject',
    align: 'left',
    render: (item: Document) => {
      const id = item.subject.subjectId

      return getSubjectType({
        id: +id,
        label: item.subject.subjectLabel,
        name: item.subject.subjectName,
        type: item.subjectType
      })
    }
  },
  {
    title: 'Frequency',
    sortable: true,
    key: 'frequency',
    align: 'left',
    render: ({ frequency }) => <FrequencyLabel name={frequency} />
  },
  {
    title: 'Expiration Date',
    sortable: true,
    key: 'expirationDate',
    align: 'left',
    render: ({ expirationDate }) => <DateTime date={expirationDate} />
  },
  {
    align: 'left',
    title: 'Alerts',
    render: (item: Document) => <DueTooltip id={item.id} alerts={item.alerts} />
  },
  {
    title: 'Actions',
    width: '50px',
    render: (item: Document) => (
      <TableActions
        items={[
          {
            type: 'edit',
            url: `${DOCUMENTS_PATH}/${item?.id}/edit?returnUrl=${encodeURIComponent(returnUrl ?? '')}`
          },
          {
            type: 'delete',
            onClick: () => onDeleteDocument(item)
          }
        ]}
      />
    )
  }
]

type Subject = {
  label: string
  name: string
  type: string
  id: number
}

const getSubjectType = (subject: Subject) => {
  switch (subject.type) {
    case 'company':
      return (
        <>
          <div>{subject.label}</div>
          <Link to="/relationships/$id" params={{ id: subject.id.toString() }}>
            {subject.name}
          </Link>
        </>
      )
    case 'license':
      return (
        <>
          <div>{subject.label}</div>
          <Link to="/licenses/$licenseId" params={{ licenseId: subject.id.toString() }}>
            {subject.name}
          </Link>
        </>
      )
    case 'bank_account':
      return (
        <>
          <div>{subject.label}</div>
          <Link to="/bank-accounts/$bankAccountId" params={{ bankAccountId: subject.id.toString() }}>
            <TextMask isBankAccount text={subject.name} iconSize={IconSize.XS} />
          </Link>
        </>
      )
    case 'contact':
      return (
        <>
          <div>{subject.label}</div>
          <Link to="/contacts/$contactId" params={{ contactId: subject.id.toString() }}>
            {subject.name}
          </Link>
        </>
      )
    default:
      return null
  }
}
